module.exports = __webpack_public_path__ + "0f6400b6282a7ff2e08aca8088a28873.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-icon003.png
// module id = 831
// module chunks = 3